//カートのアイテム削除・更新のレスポンスをキャッチ
(function(ns, fetch) {
  if (typeof fetch !== 'function') return;

  ns.fetch = function() {
    const response = fetch.apply(this, arguments);
    response.then(res => {
        if (res.url.includes('/cart/change')) {
            res.clone().json().then(data =>
              {
                /////カートにお急ぎ便アイテムだけ残った場合はカートリセット/////
                /*if(data.items.length === 1 && data.items[0].title.match(/^お急ぎ便 - 利用する/)){
                  $.ajax({
                    type: 'POST',
                    url: '/cart/clear.js',
                    data: '',
                    dataType: 'json',
                    success: function() {window.location.reload();},
                    error: function(XMLHttpRequest, textStatus) {console.log("clear.js loading failed")}
                  });
                }
                */
              }
            );
        } else if(res.url.includes('?sections=template--')){
          fetch('/cart.js')
          .then(response => response.json())
          .then(data => {
              const update_list = new Object();
              let pay_express_option = false;
              let free_exress_option = false;
              let index = 1; //列番号（１から開始）
              data['items'].forEach(item => {
                if (item.product_type === "OPTIONS_HIDDEN_PRODUCT" || item.product_type === "オプションサービス") {
                  if(item.product_title === 'お急ぎ便' || item.title.match(/^お急ぎ便 - 利用する/)){
                    pay_express_option = true;
                  }
                } else {
                  if (item.properties.hasOwnProperty('お急ぎ便')) {
                    if(item.properties.お急ぎ便 === '利用する '){ //利用する[半角スペース]（無料お急ぎ便）
                      free_exress_option = true;
                      update_list[index] = item.properties;
                    } else if(item.properties.お急ぎ便.match(/^利用する\(優先/)){
                      pay_express_option = true;
                    }
                  }  
                }
                index++;
              });
              //無料お急ぎ便ありで有料お急ぎ便なしの場合は、お急ぎ便オプション削除
              if(free_exress_option && !pay_express_option){
                removeExpressOption(update_list);
              }
          })
          .catch((error) => {
              console.log('Error:', error);
          });
          /////お急ぎ便（オプション）削除による更新/////
          /*const express_option_id = 42953503473917; //お急ぎ便ID
          const itemExpress = {items: [{id: express_option_id,quantity: 1}]};
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            async: false,
            data: itemExpress,
            dataType: 'json',
            }).done(function(data) {
              location.href='/cart';
          });
          */
        }
    });
    return response;
  }
}(window, window.fetch));

//データを順番に更新
async function removeExpressOption(data){
  for (const [key, value] of Object.entries(data)) {
    let item_properties = value;
    delete item_properties.お急ぎ便;
    //console.log(item_properties);
    let formData = {
      'line':key,
      'properties': item_properties
    };
    
    await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
          'dataType': 'json',
          'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    }).catch((error) => {
      console.log('Error:', error);
    });
  }
  sessionStorage.setItem('removeExpressOption','1');
  location.href='/cart';
}


BOLD.options.app.on("option_products_loaded", function () {
  const CartItemJSON = JSON.parse(
    document.getElementById("cart-items-obj").innerHTML
  );
  const cart_items_obj = CartItemJSON["items"];
  var checkTargets = [];
  var delivery_a, delivery_b, delivery_min_date;

  const default_delivery_a = 6;
  const default_delivery_b = 1;
  const default_delivery_c = 5;
  const default_delivery_d = 1;
//   console.log('publicHolidayArray 1=' + publicHolidayArray);
  //  console.dir(JSON.stringify(cart_items_obj));
  // カート内商品それぞれの受取希望日をチェック
  Object.keys(cart_items_obj).forEach(function (key) {
    if (
      cart_items_obj[key].product_type === "OPTIONS_HIDDEN_PRODUCT" ||
      cart_items_obj[key].product_type === "オプションサービス"
    ) {
      // オプション商品はスキップ
      return;
    }
    
    delivery_a = default_delivery_a;
    delivery_b = default_delivery_b;
    delivery_c = default_delivery_c;
    delivery_d = default_delivery_d;
    delivery_min_date = null;

    let product_id = cart_items_obj[key].product_id;
    console.log('product_id = ' + product_id);
    // 着日不可
    let disableDateFlag = false;
    if ($.inArray(product_id, targetdisableDateProducts.product_ids) !== -1) {
      // 着日不可商品群に属しているフラグを立てる
      disableDateFlag = true;
    }

    // 商品固有の納期を取得しセット (metafields.my_fields._delivery_a, metafields.my_fields._delivery_b)
    var metafieldsJSON = $.ajax({
      url:
        "https://patisserieflower-uca.myshopify.com/products/" + cart_items_obj[key].handle,
      data: "view=delivery-json",
      async: false,
    }).responseText;
    try {
      var deliveryJSON = JSON.parse(metafieldsJSON);
    // var deliveryJSON = metafieldsJSON;

//       console.log(key + ' = ' + cart_items_obj[key].product_type);
// console.log(cart_items_obj[key].handle + ' deliveryJSON = ' + JSON.stringify(deliveryJSON));
// console.log('deliveryJSON.delivery_a = ' + deliveryJSON.delivery_a);

      if (deliveryJSON.delivery_a > 0) {
        delivery_a = Number(deliveryJSON.delivery_a);
      }
      if (deliveryJSON.delivery_b > 0) {
        delivery_b = Number(deliveryJSON.delivery_b);
      }
      if (deliveryJSON.delivery_c > 0) {
        delivery_c = Number(deliveryJSON.delivery_c);
      }
      if (deliveryJSON.delivery_d > 0) {
        delivery_d = Number(deliveryJSON.delivery_d);
      }
      if (deliveryJSON.delivery_min_date) {
        delivery_min_date = deliveryJSON.delivery_min_date;
      }
    } catch (error) {
      console.log(cart_items_obj[key].handle + ' getJSON ERROR = ' + error);
    }
    // 納期チェックに必要な情報を配列に格納
    checkTargets.push({
      title: cart_items_obj[key].title,
      // product_id: cart_items_obj[key].product_id,
      // handle: cart_items_obj[key].handle,
      target_date: cart_items_obj[key]["properties"].受取希望日,
      delivery_a: delivery_a,
      delivery_b: delivery_b,
      delivery_c: delivery_c,
      delivery_d: delivery_d,
      delivery_min_date: delivery_min_date,
      delivery_way: cart_items_obj[key]["properties"].受取方法,
      delivery_express: cart_items_obj[key]["properties"].お急ぎ便,
      update_url:
        "/cart/change?line=" +
        (Number(key) + 1) +
        "&amp;quantity=" +
        cart_items_obj[key].quantity,
      properties: cart_items_obj[key].properties,
      disable_date_flag: disableDateFlag
    });
  });

  // console.dir(checkTargets);

  // console.log('update start');

  var updateCheck = false;
  // 納期をチェック
  for (check in checkTargets) {
    var newTarget = checkPastDateAndHoliday(
      checkTargets[check],
      publicHolidayArray
    );
    // console.log('newTarget='+newTarget);
    if (newTarget) {
      updateCheck = true;

      // console.log('受取希望日 = ' + checkTargets[check].target_date);
      // console.log('最短日時 = ' + newTarget);

      // パラメーターをqueryに変換してカート編集URLと連結
      var params = checkTargets[check].properties;
      var updateUrl = checkTargets[check].update_url;
      Object.keys(params).forEach(function (property) {
        if (property === "受取希望日") {
          updateUrl +=
            "&amp;properties[" +
            url_encode(property) +
            "]=" +
            url_encode(newTarget);
        } else {
          updateUrl +=
            "&amp;properties[" +
            url_encode(property) +
            "]=" +
            url_encode(params[property]);
        }
      });
      // 受取希望日を最短日時に変更する同期リクエスト
      var x = new XMLHttpRequest();
      x.open("GET", updateUrl, false);
      x.send();
      if (x.status === 200) {
        var res = x.responseText;
        var res = x.responseText;
        console.log(checkTargets[check].title + "の受取希望日を変更しました");
      } else {
        console.log(
          checkTargets[check].title + "の受取希望日を変更できませんでした"
        );
      }
    }
  }

  // console.log('updateCheck='+updateCheck);
  // console.log('update end');
  // 更新ありの場合はリロード
  let removeExpressOption = sessionStorage.getItem('removeExpressOption');
  if(removeExpressOption){
    sessionStorage.removeItem('removeExpressOption');
    alert("基準となるお急ぎ便オプションありの商品が削除されたため、受取希望日を通常便の日に変更させていただきました。");
    window.location.reload();
  } else if (
    updateCheck &&
    !alert(
      "カートに入れてから時間が経過したため、受取希望日を最短の日に変更させていただきました"
    )
  ) {
    // ページをリロード
    window.location.reload();
  } else {
    $("#main-cart-items").show();
  }

}); // end BOLD.options


  // 最短日以前選択時に最短日時を返す
  function checkPastDateAndHoliday(data, publicHolidayArray) {
    // 選択曜日
    // var selectedDate = moment(data.target_date).day();

    console.log('選択済受取希望日 = '+data.target_date);
    console.log('着日不可商品 = '+data.disable_date_flag);

    // 祝日特別対応追加日
    var holiday_add_days = getHolidayAdd();

    // お急ぎ便の値をセット
    if (data.delivery_express) {
        var delivery_express_value = data.delivery_express;
    } else {// お急ぎ便選択フォームがない場合は全て通常
        var delivery_express_value = '通常';
    }
    // 受取方法の値をセット
    if (data.delivery_way) {
        var delivery_way_val = data.delivery_way;
    } else {
        var delivery_way_val = '';
    }

    var days = getDays(delivery_way_val, delivery_express_value, {a: data.delivery_a, b: data.delivery_b, c: data.delivery_c, d: data.delivery_d});
    days = days + holiday_add_days;

    // 最短日より過去の日付のチェック
    // 現在日付
    var now = moment();

    if (! isSunday(now) && !isHoliday(now)) {
      // 営業日：15時以降はプラス1日
      if (Number(now.format("H")) >= 15) {
        // 15時以降は翌日からカウントするのでプラス1日
        days = ++days;
      }
      var target = now;
    } else {
      // 日曜日・休業日 は翌営業日まで時間をすすめる
      var next_business_day = now;
      while (isSunday(next_business_day) || isHoliday(next_business_day)) {
        next_business_day = now.add(1, "days");
      }
      var target = next_business_day;
    }


    // 追加日数分カウントアップする
    var i=0;
    var c=1;

  // 配送か店頭受取か
  if (delivery_way_val.match(/^店頭受取/)) {
    shipping = false;
  } else {
    shipping = true;
  }

    while (c <= days) {
      // 現在日付に１日ずつプラス
      if (i === 0) {
        // 当日
        target = now;
      } else {
        // 翌日以降
        target = now.add(1, "days");
      }

      if (shipping && c === days && days > ahead_shipping_business_days) {
        // 配送の場合の最終営業日は日・祝をスキップしない
        c++;
      }else if (!isSunday(target) && !isHoliday(target)) {
        // 日曜日・休業日以外のみカウントアップ
        c++;
      }
        i++;
    }

    if (shipping) {
      // 配送に1日かかると仮定して1日追加
      target = now.add(1, "days");
    }

console.log('data.delivery_min_date='+data.delivery_min_date);

    // 最短納期日付の `delivery_min_date` が設定されている場合
    if (data.delivery_min_date && moment(data.delivery_min_date).diff(target, 'days') > 0) {
      // 受取希望日の `min`(target)より `delivery_min_date` の方が後の場合、targetを `delivery_min_date` で上書き
      target = moment(data.delivery_min_date);
    }

    // // 着日指定不可がセットされている場合は指定不可期間明けを最短日として上書き
    if (data.disable_date_flag) {
      if (target.isBetween(targetdisableDateProducts.from, targetdisableDateProducts.to, null, '[]')) {
        target = moment(targetdisableDateProducts.to).add(1, "days");
      }
    }

    console.log('最短日 = '+ target.format('YYYY-MM-DD'));

    // 選択済みの場合
    if (data.target_date) {
      // 着日指定不可がセットされている場合
      if (data.disable_date_flag) {
        console.log('targetdisableDateProducts = ' + JSON.stringify(targetdisableDateProducts));
        // 選択日が着日指定不可期間の場合、指定不可期間明けをセット
        if (moment(data.target_date).isBetween(targetdisableDateProducts.from, targetdisableDateProducts.to, null, '[]')) {
          return target.format("YYYY-MM-DD");
        }
      }
      // 選択済みの日付が範囲外
      if (moment(data.target_date).diff(target.format('YYYY-MM-DD'), 'days') < 0) {
        return target.format('YYYY-MM-DD');
      }
      // 「店頭受取」で選択済みの日付が日曜日・休業日
      if (! shipping && (isSunday(moment(data.target_date)) || isHoliday(moment(data.target_date)))) {
        return target.format('YYYY-MM-DD');
      }
    }

    return false;
}

function url_encode(string)
{
    return encodeURIComponent((string+'')).replace(/!/g,'%21').replace(/'/g,'%27').replace(/\(/g,'%28').replace(/\)/g,'%29').replace(/\*/g,'%2A').replace(/%20/g,'+');
}